import React from 'react';
import { Collapse } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Reusable nested filter panel component (for extra filters)
 * @param {Object} props
 * @param {Array} props.sections - Array of section configurations
 * @param {Object} props.filters - Current filter values
 * @param {Function} props.onFilterChange - Filter change handler
 * @param {string} props.expandIcon - Icon component for expand/collapse
 * @param {Function} props.countSelections - Function to count selections
 * @param {Object} props.filterLabels - Labels for cold start restoration
 * @returns {JSX.Element}
 */
const NestedFilterPanel = ({
  sections,
  filters,
  onFilterChange,
  expandIcon,
  countSelections,
  aggregations,
  filterLabels,
}) => {
  const { t } = useTranslation();

  const getDefaultActiveKeys = () => {
    return sections
      .filter((section) => countSelections(section.filterKeys) > 0)
      .map((section) => section.key);
  };

  const items = sections.map((section) => {
    const count = countSelections(section.filterKeys);
    return {
      key: section.key,
      className: 'collapse-nested',
      label: <p className="collapse-nested-title">{t(section.labelKey)}</p>,
      extra: count > 0 && <span className="ms-2"> ( {count} )</span>,
      children: (
        <section.Component
          filters={filters}
          onFilterChange={onFilterChange}
          aggregations={aggregations}
          filterLabels={filterLabels}
        />
      ),
    };
  });

  return (
    <Collapse
      defaultActiveKey={getDefaultActiveKeys()}
      items={items}
      ghost
      expandIconPosition="start"
      expandIcon={expandIcon}
      accordion
    />
  );
};

export default NestedFilterPanel;
